var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWholesaleSaveo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_473_1",
    "data-name": "Component 473 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 233.801,
    height: 55.928,
    viewBox: "0 0 233.801 55.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_660",
    "data-name": "Rectangle 660",
    width: 232.308,
    height: 55.928,
    fill: "#F0FFFB",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19023",
    "data-name": "Group 19023",
    transform: "translate(0.567 1.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19021",
    "data-name": "Group 19021",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M1312.823,153.474c-.033-3.413-.07-7.283-.07-10.944,0-1.705-1.261-3.618-3.07-3.635-16.36-.16-29.113-.2-43.881-.248-5.021-.016-10.279-.033-16-.055-.612,0-1.212-1.617-1.535-2.483-.1-.276-.2-.537-.295-.771-.07-.228-.139-.44-.207-.642a7.406,7.406,0,0,1-.356-1.352,1.137,1.137,0,0,1,.23-.895,2.2,2.2,0,0,1,1.451-.718h57.387a1.815,1.815,0,1,0,0-3.631h-57.487c-.06,0-.12,0-.179.008a5.83,5.83,0,0,0-4.032,2.1,4.763,4.763,0,0,0-.964,3.653,10.755,10.755,0,0,0,.51,2c.063.192.129.392.2.613.019.063.042.126.065.18.085.2.172.437.277.719.627,1.691,1.794,4.839,4.925,4.852,5.284.02,10.176.036,14.85.051l1.15,0c14.611.047,27.247.087,43.331.24v.012c0,3.6.035,7.294.071,10.871v.108c.07,7.227.142,14.7-.067,21.974a.5.5,0,0,1-.124.1c-21.814.3-37.276.3-59.056,0a3.907,3.907,0,0,1-3.12-2.64,42.732,42.732,0,0,1-.058-5.822c.034-.992.07-2.017.07-3.037a1.816,1.816,0,0,0-3.632,0c0,.978-.037,2.02-.069,2.954a44.634,44.634,0,0,0,.076,6.261l.014.122a7.383,7.383,0,0,0,6.326,5.775,2.129,2.129,0,0,0,.219.016c11.373.157,20.513.227,29.641.227s18.267-.07,29.614-.227a3.81,3.81,0,0,0,3.726-3.583C1312.966,168.33,1312.893,160.8,1312.823,153.474Z",
    transform: "translate(-1243.063 -128.099)",
    fill: "#F0FFFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M1306.079,159.164h-13.188c-.7,0-1.228-.437-1.228-.829V152.17c0-.391.524-.828,1.228-.828h13.188a1.578,1.578,0,0,0,0-3.156h-13.188a4.174,4.174,0,0,0-4.333,3.984v6.164a4.174,4.174,0,0,0,4.333,3.984h13.188a1.578,1.578,0,0,0,0-3.155Z",
    transform: "translate(-1235.342 -124.69)",
    fill: "#F0FFFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M1295.845,152.7a1.778,1.778,0,1,0,1.828,1.777A1.805,1.805,0,0,0,1295.845,152.7Z",
    transform: "translate(-1234.416 -123.923)",
    fill: "#F0FFFB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(91.668 1.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1348.171,141.879a24.313,24.313,0,0,0-4.594-1.523,12.373,12.373,0,0,1-3.782-1.4,2.443,2.443,0,0,1-1.113-2.156,3.084,3.084,0,0,1,1.255-2.618,5.577,5.577,0,0,1,3.418-.941,8.033,8.033,0,0,1,3,.5,10.531,10.531,0,0,1,2.527,1.523,4.665,4.665,0,0,0,.715.376,1.639,1.639,0,0,0,.59.1,1.151,1.151,0,0,0,.937-.531,2.031,2.031,0,0,0,.4-1.249,2.081,2.081,0,0,0-.175-.908,2.565,2.565,0,0,0-.588-.735,10.582,10.582,0,0,0-7.406-2.6,10.324,10.324,0,0,0-4.467.94,7.457,7.457,0,0,0-3.1,2.619,6.724,6.724,0,0,0-1.112,3.8,5.989,5.989,0,0,0,.89,3.389,6.521,6.521,0,0,0,2.639,2.191,21.725,21.725,0,0,0,4.545,1.506,14.623,14.623,0,0,1,3.863,1.352,2.214,2.214,0,0,1,1.162,2,2.92,2.92,0,0,1-1.241,2.55,6.145,6.145,0,0,1-3.56.873,10.783,10.783,0,0,1-3.307-.48,9.234,9.234,0,0,1-2.86-1.54,2.475,2.475,0,0,0-1.3-.48,1.155,1.155,0,0,0-.937.531,2.016,2.016,0,0,0-.4,1.25,1.975,1.975,0,0,0,.73,1.642,9.881,9.881,0,0,0,3.544,1.9,15.011,15.011,0,0,0,4.626.7,10.886,10.886,0,0,0,4.561-.907,7.232,7.232,0,0,0,3.084-2.533,6.545,6.545,0,0,0,1.1-3.747,5.416,5.416,0,0,0-.938-3.252A6.87,6.87,0,0,0,1348.171,141.879Z",
    transform: "translate(-1334.168 -126.762)",
    fill: "#F0FFFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1375.877,131.207a2.162,2.162,0,0,0-.875-1.043,2.372,2.372,0,0,0-2.511,0,2.161,2.161,0,0,0-.874,1.043l-8.773,20.292a2.258,2.258,0,0,0-.192.889,1.728,1.728,0,0,0,.606,1.334,1.937,1.937,0,0,0,1.335.548,1.762,1.762,0,0,0,.984-.291,1.909,1.909,0,0,0,.7-.907l1.907-4.585h11.189l1.908,4.585a1.916,1.916,0,0,0,.7.907,1.716,1.716,0,0,0,.954.291,1.918,1.918,0,0,0,1.35-.548,1.751,1.751,0,0,0,.588-1.334,2.257,2.257,0,0,0-.189-.889Zm-6.294,13.858,4.195-10.162,4.2,10.162Z",
    transform: "translate(-1333.912 -126.75)",
    fill: "#F0FFFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M1414.2,130.351a2.142,2.142,0,0,0-1.43-.547,1.737,1.737,0,0,0-1.687,1.164l-7.311,17.486-7.311-17.486a1.891,1.891,0,0,0-.717-.874,1.846,1.846,0,0,0-1-.291,2.235,2.235,0,0,0-1.477.547,1.749,1.749,0,0,0-.651,1.4,2.3,2.3,0,0,0,.19.821l8.773,20.4a2.191,2.191,0,0,0,.875,1.009,2.371,2.371,0,0,0,2.511,0,2.19,2.19,0,0,0,.876-1.009l8.805-20.4a2.361,2.361,0,0,0,.19-.857A1.736,1.736,0,0,0,1414.2,130.351Z",
    transform: "translate(-1333.644 -126.75)",
    fill: "#F0FFFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M1439.76,133.479a2.051,2.051,0,0,0,1.429-.463,1.688,1.688,0,0,0,.509-1.317,1.592,1.592,0,0,0-.509-1.265,2.106,2.106,0,0,0-1.429-.445h-11.477a1.9,1.9,0,0,0-1.445.548,2.129,2.129,0,0,0-.525,1.539v19.943a2.129,2.129,0,0,0,.525,1.539,1.9,1.9,0,0,0,1.445.548h11.477a2.106,2.106,0,0,0,1.429-.445,1.592,1.592,0,0,0,.509-1.266,1.692,1.692,0,0,0-.509-1.317,2.056,2.056,0,0,0-1.429-.46h-9.442V143.57h8.805a2.1,2.1,0,0,0,1.43-.445,1.591,1.591,0,0,0,.508-1.266,1.635,1.635,0,0,0-.508-1.3,2.1,2.1,0,0,0-1.43-.444h-8.805v-6.637Z",
    transform: "translate(-1333.234 -126.725)",
    fill: "#F0FFFB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M1474.313,138.938l-4,.65a16.051,16.051,0,0,1,.233,2.8,10.781,10.781,0,0,1-1.732,6.585,6.229,6.229,0,0,1-9.666,0,10.784,10.784,0,0,1-1.732-6.585q0-4.288,1.732-6.569a5.741,5.741,0,0,1,4.848-2.281,6.184,6.184,0,0,1,2.948.7l-1.712,3.287.367-.046,8.124-1.319-3.065-9.051-2.014,3.865a10.879,10.879,0,0,0-4.647-.969,10.523,10.523,0,0,0-5.69,1.509,9.726,9.726,0,0,0-3.7,4.3,17.346,17.346,0,0,0,.015,13.154,9.833,9.833,0,0,0,3.7,4.322,11.362,11.362,0,0,0,11.319,0,9.845,9.845,0,0,0,3.7-4.322,15.531,15.531,0,0,0,1.3-6.585A17.677,17.677,0,0,0,1474.313,138.938Z",
    transform: "translate(-1333.081 -127.109)",
    fill: "#F0FFFB"
  })), /*#__PURE__*/React.createElement("text", {
    id: "WholeSale_Mart",
    "data-name": "WholeSale Mart",
    transform: "translate(90.901 49.46)",
    fill: "#F0FFFB",
    fontSize: 6.95,
    fontFamily: "Ubuntu",
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FUTURE OF HEALTH CARE DELIVERY")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWholesaleSaveo);
export default __webpack_public_path__ + "static/media/wholesale_saveo.b9478e5680784172b6ad44de20a83dd1.svg";
export { ForwardRef as ReactComponent };